// Stands in for Vimeo in the browser test (see
// Orientation::VideoStep::Component#fake_player?). It plays in real time on a
// timer and implements the small part of the @vimeo/player API the controller
// uses, so the server's crediting is exercised exactly as in production.
export default class FakePlayer {
  constructor(element, { duration, speed }) {
    this.duration = duration;
    this.speed = speed;
    this.currentTime = 0;
    this.rate = 1;
    this.listeners = {};
    element.textContent = "Test player";
    element.style.color = "white";
    // Lets a browser test have the player report something.
    element.fakePlayer = this;
  }

  ready() {
    return Promise.resolve();
  }

  on(event, callback) {
    (this.listeners[event] ||= []).push(callback);
  }

  emit(event, data) {
    (this.listeners[event] || []).forEach((callback) => callback(data));
  }

  // What real Vimeo did when tried on 2026-11-02: a player built without `speed`
  // refuses any rate, even 1, and sends an error event as well as rejecting.
  setPlaybackRate(rate) {
    if (!this.speed) {
      const message = "Setting the playback rate is not enabled for this video.";
      this.emit("error", { name: "Error", message, method: "setPlaybackRate" });
      return Promise.reject(new Error(message));
    }

    this.rate = rate;
    return Promise.resolve(rate);
  }

  setCurrentTime(seconds) {
    this.currentTime = seconds;
    this.emit("seeked", { seconds });
    return Promise.resolve(seconds);
  }

  getCurrentTime() {
    return Promise.resolve(this.currentTime);
  }

  requestFullscreen() {
    return Promise.resolve();
  }

  destroy() {
    clearInterval(this.timer);
    return Promise.resolve();
  }

  play() {
    clearInterval(this.timer);
    this.emit("play", { seconds: this.currentTime });
    this.timer = setInterval(() => {
      this.currentTime = Math.min(this.duration, this.currentTime + 0.25 * this.rate);
      this.emit("timeupdate", { seconds: this.currentTime, duration: this.duration });
      if (this.currentTime >= this.duration) {
        clearInterval(this.timer);
        this.emit("ended", { seconds: this.duration });
      }
    }, 250);
    return Promise.resolve();
  }

  pause() {
    clearInterval(this.timer);
    this.emit("pause", { seconds: this.currentTime });
    return Promise.resolve();
  }
}
